import i18n from 'i18n'

// Backend 409 error codes -> localized message. Getters so the text follows
// the current language at access time; unknown codes stay undefined.
export const ErrorEnumMessage = {
  // partial
  get TRANSFER_DATE_BEFORE_START_DATE_CYCLE(): string {
    return i18n.t('common:error.TRANSFER_DATE_BEFORE_START_DATE_CYCLE')
  },
  get PARTIAL_TRANSFER_DATE_BEFORE_TOPUP_DATE(): string {
    return i18n.t('common:error.PARTIAL_TRANSFER_DATE_BEFORE_TOPUP_DATE')
  },
  get PARTIAL_TRANSFER_DATE_BEFORE_LAST_TRANSFER_DATE(): string {
    return i18n.t('common:error.PARTIAL_TRANSFER_DATE_BEFORE_LAST_TRANSFER_DATE')
  },
  get PARTIAL_TRANSFER_DATE_AFTER_DATE_NOW(): string {
    return i18n.t('common:error.PARTIAL_TRANSFER_DATE_AFTER_DATE_NOW')
  },
  get CANNOT_UPDATE_PARTIAL_TRANSFER_DUE_TO_EXISTING_TRANSFER(): string {
    return i18n.t('common:error.CANNOT_UPDATE_PARTIAL_TRANSFER_DUE_TO_EXISTING_TRANSFER')
  },
  get CANNOT_UPDATE_PARTIAL_TRANSFER(): string {
    return i18n.t('common:error.CANNOT_UPDATE_PARTIAL_TRANSFER')
  },

  // shrimp topup
  get SHRIMP_TOPUP_DATE_BEFORE_TRANSFER_DATE(): string {
    return i18n.t('common:error.SHRIMP_TOPUP_DATE_BEFORE_TRANSFER_DATE')
  },
  get SHRIMP_TOPUP_DATE_BEFORE_START_DATE_CYCLE(): string {
    return i18n.t('common:error.SHRIMP_TOPUP_DATE_BEFORE_START_DATE_CYCLE')
  },
  get SHRIMP_TOPUP_DATE_BEFORE_LAST_SHRIMP_TOPUP_DATE(): string {
    return i18n.t('common:error.SHRIMP_TOPUP_DATE_BEFORE_LAST_SHRIMP_TOPUP_DATE')
  },
  get SHRIMP_TOPUP_DATE_AFTER_DATE_NOW(): string {
    return i18n.t('common:error.SHRIMP_TOPUP_DATE_AFTER_DATE_NOW')
  },
  get CANNOT_UPDATE_SHRIMP_TOPUP(): string {
    return i18n.t('common:error.CANNOT_UPDATE_SHRIMP_TOPUP')
  },

  //pond
  get POND_NAME_ALREADY_EXIST(): string {
    return i18n.t('common:error.POND_NAME_ALREADY_EXIST')
  },

  // cycle
  get INITIAL_SHRIMP_COUNT_UPDATE_BLOCKED_BY_PARTIAL_TRANSFER(): string {
    return i18n.t('common:error.INITIAL_SHRIMP_COUNT_UPDATE_BLOCKED_BY_PARTIAL_TRANSFER')
  },

  //product
  get PRODUCT_NAME_DUPLICATION(): string {
    return i18n.t('common:error.PRODUCT_NAME_DUPLICATION')
  },
  get PRODUCT_CODE_DUPLICATION(): string {
    return i18n.t('common:error.PRODUCT_CODE_DUPLICATION')
  },
  get LOT_NUMBER_DUPLICATION(): string {
    return i18n.t('common:error.LOT_NUMBER_DUPLICATION')
  },
  get STOCK_HAS_PRODUCT(): string {
    return i18n.t('common:error.STOCK_HAS_PRODUCT')
  },
  get PRODUCT_DUPLICATION(): string {
    return i18n.t('common:error.PRODUCT_DUPLICATION')
  },

  //category
  get CATEGORY_HAS_PRODUCTS(): string {
    return i18n.t('common:error.CATEGORY_HAS_PRODUCTS')
  },
  get CANNOT_DELETE_DEFAULT_CATEGORY(): string {
    return i18n.t('common:error.CANNOT_DELETE_DEFAULT_CATEGORY')
  },
  get CATEGORY_NAME_DUPLICATION(): string {
    return i18n.t('common:error.CATEGORY_NAME_DUPLICATION')
  },

  //stock
  get STOCK_NOT_ENOUGH(): string {
    return i18n.t('common:error.STOCK_NOT_ENOUGH')
  },
  get DESTINATION_POND_CANNOT_MODIFY_AMOUNT(): string {
    return i18n.t('common:error.DESTINATION_POND_CANNOT_MODIFY_AMOUNT')
  },
  get CYCLE_HAS_PARTIAL_TRANSFERS(): string {
    return i18n.t('common:error.CYCLE_HAS_PARTIAL_TRANSFERS')
  },
  get CANNOT_DELETE_DESTINATION_POND_CYCLE(): string {
    return i18n.t('common:error.CANNOT_DELETE_DESTINATION_POND_CYCLE')
  },
  get DESTINATION_WAREHOUSE_CLOSE_NOT_ALLOWED(): string {
    return i18n.t('common:error.DESTINATION_WAREHOUSE_CLOSE_NOT_ALLOWED')
  },
  get STOCK_NOT_FOUND(): string {
    return i18n.t('common:error.STOCK_NOT_FOUND')
  },
  get STOCK_IN_USE_BY_MEAL(): string {
    return i18n.t('common:error.STOCK_IN_USE_BY_MEAL')
  },
  get STOCK_IN_USE_BY_MEDICINE(): string {
    return i18n.t('common:error.STOCK_IN_USE_BY_MEDICINE')
  },
  get INVENTORY_STOCK_DUPLICATION(): string {
    return i18n.t('common:error.INVENTORY_STOCK_DUPLICATION')
  },

  //iot device
  get IOT_DEVICE_ALREADY_IN_USE(): string {
    return i18n.t('common:error.IOT_DEVICE_ALREADY_IN_USE')
  },
  get IOT_DEVICE_DUPLICATION(): string {
    return i18n.t('common:error.IOT_DEVICE_DUPLICATION')
  },

  //warehouse
  get WAREHOUSE_HAS_STOCK(): string {
    return i18n.t('common:error.WAREHOUSE_HAS_STOCK')
  },
  get WAREHOUSE_NAME_DUPLICATION(): string {
    return i18n.t('common:error.WAREHOUSE_NAME_DUPLICATION')
  },

  //cost
  get CANNOT_DELETE_COST_TRANSACTION(): string {
    return i18n.t('common:error.CANNOT_DELETE_COST_TRANSACTION')
  },
  get CANNOT_UPDATE_UNIT_PRICE_DELETED_STOCK(): string {
    return i18n.t('common:error.CANNOT_UPDATE_UNIT_PRICE_DELETED_STOCK')
  },

  // credit promotion
  get CREDIT_PROMOTION_NOT_FOUND(): string {
    return i18n.t('common:error.CREDIT_PROMOTION_NOT_FOUND')
  },
  get CREDIT_PROMOTION_STATUS_NOT_ACTIVE(): string {
    return i18n.t('common:error.CREDIT_PROMOTION_STATUS_NOT_ACTIVE')
  },
  get CREDIT_PROMOTION_ALREADY_USED(): string {
    return i18n.t('common:error.CREDIT_PROMOTION_ALREADY_USED')
  },
  get CREDIT_PROMOTION_GLOBAL_USAGE_LIMIT_EXCEEDED(): string {
    return i18n.t('common:error.CREDIT_PROMOTION_GLOBAL_USAGE_LIMIT_EXCEEDED')
  },
  get INVALID_CREDIT_PROMOTION_USAGE_SCOPE(): string {
    return i18n.t('common:error.INVALID_CREDIT_PROMOTION_USAGE_SCOPE')
  },

  // growth
  get SHRIMP_GROWTH_DUPLICATION(): string {
    return i18n.t('common:error.SHRIMP_GROWTH_DUPLICATION')
  },
  get CANNOT_DELETE_DEFAULT_SHRIMP_GROWTH(): string {
    return i18n.t('common:error.CANNOT_DELETE_DEFAULT_SHRIMP_GROWTH')
  },
  get CYCLE_NOT_FOUND(): string {
    return i18n.t('common:error.CYCLE_NOT_FOUND')
  },

  //meal / food
  get STOCK_IS_REQUIRED(): string {
    return i18n.t('common:error.STOCK_IS_REQUIRED')
  },
  get REMAINING_FOOD_MUST_BE_POSITIVE(): string {
    return i18n.t('common:error.REMAINING_FOOD_MUST_BE_POSITIVE')
  },
  get REMAINING_FOOD_CANNOT_EXCEED_AMOUNT(): string {
    return i18n.t('common:error.REMAINING_FOOD_CANNOT_EXCEED_AMOUNT')
  },
  get AMOUNT_MUST_BE_POSITIVE(): string {
    return i18n.t('common:error.AMOUNT_MUST_BE_POSITIVE')
  },
  get NATURAL_AMOUNT_MUST_BE_POSITIVE(): string {
    return i18n.t('common:error.NATURAL_AMOUNT_MUST_BE_POSITIVE')
  },
  get INVALID_FEEDING_TYPE(): string {
    return i18n.t('common:error.INVALID_FEEDING_TYPE')
  },
  get INVALID_MEAL_STATUS(): string {
    return i18n.t('common:error.INVALID_MEAL_STATUS')
  },
  get INVENTORY_STOCK_OUTSIDE_ORGANIZATION(): string {
    return i18n.t('common:error.INVENTORY_STOCK_OUTSIDE_ORGANIZATION')
  },

  // feed program (total yield formula)
  get PROGRAM_NAME_DUPLICATE(): string {
    return i18n.t('common:error.PROGRAM_NAME_DUPLICATE')
  },
  get DUPLICATE_SHRIMP_WEIGHT(): string {
    return i18n.t('common:error.DUPLICATE_SHRIMP_WEIGHT')
  },
  get PROGRAM_IN_USE(): string {
    return i18n.t('common:error.PROGRAM_IN_USE')
  },
  get PROGRAM_DETAILS_TOO_FEW(): string {
    return i18n.t('common:error.PROGRAM_DETAILS_TOO_FEW')
  },
  get PROGRAM_DETAILS_TOO_MANY(): string {
    return i18n.t('common:error.PROGRAM_DETAILS_TOO_MANY')
  },
  get FORBIDDEN_SYSTEM_PROGRAM(): string {
    return i18n.t('common:error.FORBIDDEN_SYSTEM_PROGRAM')
  },
}
